"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsProvider = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var PropTypes = __importStar(require("prop-types"));
var shisell_1 = require("shisell");
var shisell_context_1 = require("./shisell-context");
var LazyAnalytics = (function () {
    function LazyAnalytics(dispatcherFactory) {
        this.dispatcherFactory = dispatcherFactory;
    }
    Object.defineProperty(LazyAnalytics.prototype, "dispatcher", {
        get: function () {
            return this.dispatcherFactory();
        },
        enumerable: false,
        configurable: true
    });
    return LazyAnalytics;
}());
var LazyAnalyticsProvider = (function (_super) {
    __extends(LazyAnalyticsProvider, _super);
    function LazyAnalyticsProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.analytics = new LazyAnalytics(function () { return _this.props.getDispatcher(); });
        return _this;
    }
    LazyAnalyticsProvider.prototype.render = function () {
        return react_1.default.createElement(shisell_context_1.ShisellContext.Provider, { value: this.analytics }, this.props.children);
    };
    return LazyAnalyticsProvider;
}(react_2.Component));
var AnalyticsProvider = function (_a) {
    var dispatcher = _a.dispatcher, children = _a.children;
    if (typeof dispatcher === 'function') {
        return (react_1.default.createElement(shisell_context_1.ShisellContext.Consumer, null, function (analytics) { return (react_1.default.createElement(LazyAnalyticsProvider, { getDispatcher: function () { return dispatcher(analytics.dispatcher); } }, children)); }));
    }
    return react_1.default.createElement(LazyAnalyticsProvider, { getDispatcher: function () { return dispatcher; } }, children);
};
exports.AnalyticsProvider = AnalyticsProvider;
exports.AnalyticsProvider.propTypes = {
    dispatcher: PropTypes.oneOfType([PropTypes.instanceOf(shisell_1.AnalyticsDispatcher), PropTypes.func]).isRequired,
};
